<template>
  <article class="navigation-search">
    <section class="navigation-search__bar">
      <InputSearchQuery id="search" placeholder="Que cherchez-vous?" />
    </section>

    <KeywordPickerQuery :dataset="allPublications" />
  </article>
</template>

<script>
export default {
  name: 'NewsSearch',
  computed: {
    allPublications() {
      return this.$wp.newsPublications || []
    }
  }
}
</script>
